import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ParameterProvider } from "cw-backend";
import { BehaviorSubject } from "rxjs";
import { MedicalProvider } from "../../../../../../../../shared/cw-backend/providers/operational/medical/medical.provider";

declare var DocsAPI: any;

@Injectable({
    providedIn: "root",
})
export class OnllyofficeService {
    public documentStateSubject = new BehaviorSubject<boolean>(false);
    documentState$ = this.documentStateSubject.asObservable();

    Editor: any;
    urlSaveDocument: string;
    editorEvent: any;
    private saveTimeout: any = null;
    private documentKey: string;
    private editorModifiedSinceLoad = false;
    private editRevision = 0;
    private confirmedRevision = 0;
    ipApiOnlyoffice: any;

    constructor(
        public http: HttpClient,
        private medicalProvider: MedicalProvider,
        private parameterService?: ParameterProvider,
    ) {
        this.urlSaveDocument = `http://127.0.0.1/`;
        // this.getParameterOnllyoffice();
    }

    getParameterOnlyoffice(): Promise<any> {
        return this.parameterService
            .getParameterByName("IP_API_ONLYOFFICE")
            .then((res) => {
                this.ipApiOnlyoffice = res.body;
                return res.body;
            });
    }

    async load() {
        if (window["DocsAPI"]) return;

        try {
            await this.getParameterOnlyoffice();

            if (this.ipApiOnlyoffice?.value) {
                return new Promise((resolve, reject) => {
                    const script = document.createElement("script");
                    script.type = "text/javascript";
                    script.src = this.ipApiOnlyoffice.value;
                    script.onload = () => resolve(true);
                    script.onerror = () => reject("Erro ao carregar script");
                    document.body.appendChild(script);
                });
            }
        } catch (error) {
            console.error("Erro na inicialização:", error);
        }
    }

    innerAlert(message: any) {}

    onAppReady(event: any) {
        setTimeout(() => {
            if (!this.editorModifiedSinceLoad || !this.documentStateSubject.value) {
                this.documentStateSubject.next(false);
            }
        }, 2000);
    }

    onDestroyEditor(editor?) {
        if (this.Editor && typeof this.Editor.destroyEditor === "function") {
            try {
                this.Editor.destroyEditor();
                this.Editor = null; // Limpa a referência após destruir
                console.log("Editor destruído com sucesso.");
            } catch (error) {
                console.error("Erro ao tentar destruir o editor:", error);
            }
        } else {
            console.warn("Nenhuma instância de editor ativa para destruir.");
        }
    }

    onRequestClose(event: any) {
        if (window.opener) {
            window.close();
            return;
        }

        DocsAPI.DocEditor("texto").destroyEditor();
    }

    onDocumentStateChange = (event: any) => {
        if (event.data === true) {
            this.editorModifiedSinceLoad = true;
            this.editRevision++;
        }
        this.documentStateSubject.next(event.data);
    };

    wasModifiedInCurrentSession(): boolean {
        return this.editRevision > this.confirmedRevision;
    }

    getEditRevision(): number {
        return this.editRevision;
    }

    markRevisionSaved(key: string, revision: number): boolean {
        if (this.documentKey === key && this.editRevision === revision
                && !this.documentStateSubject.value) {
            this.confirmedRevision = revision;
            return true;
        }
        return false;
    }

    onRequestMailMergeRecipients(event: any) {
        this.Editor.setMailMergeRecipients({
            fileType: "docx",
            url: `${this.urlSaveDocument}document-model/download?id_document=38`,
        });
    }

    onRequestEditRights(event: any) {
        location.href = location.href.replace(RegExp("action=view&?", "i"), "");
    }

    onError(event: any) {
        if (event) this.innerAlert(event.data);
    }

    onOutdatedVersion(event: any) {
        location.reload();
    }

    onPluginsReady(event: any) {}

    downloadDocument(event: any) {
        var fileType = event.data.fileType;
        var url = event.data.url;
    }

    onDownloadAs(Editor) {
        Editor.downloadAs("docx");
    }

    onWarning(event) {}

    onRequestSaveAs(key: any) {
        document.getElementById("asc-gen542").click();

        var obj = {
            c: "forcesave",
            key: key,
            userdata: "saving",
        };

        this.http
            .post(
                `${this.urlSaveDocument}coauthoring/CommandService.ashx`,
                obj,
                { headers: { "access-control-allow-origin": "*" } },
            )
            .subscribe({});
    }

    alterDocumentStateSubject = (event: boolean) => {
        this.documentStateSubject.next(event);
    };

    static editorInstance = new EventEmitter<any>();

    сonnectEditor(config: any) {
        console.log("🚀 --> config:", config);
        this.editorModifiedSinceLoad = false;
        this.editRevision = 0;
        this.confirmedRevision = 0;
        this.documentStateSubject.next(true);
        let teste;

        if (config !== teste) {
            try {
                teste = config;

                // cria o editor
                this.Editor = DocsAPI.DocEditor(config.container, {
                    width: "100%",
                    height: config.height,
                    type: config.type || "desktop",
                    documentType: config.documentType || "word",
                    plugins: {
                        autostart: [
                            "asc.{CF3A000F-C6B4-451D-AC0B-F3DDAB1880D2}",
                        ],
                        pluginsData: [
                            "http://127.0.0.1/sdkjs-plugins/pontodeparadaF2/config.json",
                        ],
                    },
                    document: {
                        title: config.title,
                        url: config.url,
                        fileType: config.fileType,
                        key: config.key, // 👈 chave única do documento
                        info: {
                            author: "Clinicall Web",
                            created: "Clinicall Web",
                        },
                        permissions: {
                            comment: false,
                            edit: config.edit,
                            download: false,
                            print: true,
                            review: false,
                        },
                    },
                    customHeaders: {
                        "X-Auth-Token": localStorage.getItem("token"),
                    },
                    editorConfig: {
                        embedded: {
                            embedUrl: config.url,
                            saveUrl: config.url,
                            shareUrl: config.url,
                            toolbarDocked: "top",
                        },
                        mode: config.mode,
                        lang: "pt-BR",
                        createUrl: config.createUrl,
                        callbackUrl: config.callbackUrl,
                        saveInterval: "1000",
                        saveAsUrl: "",
                        user: {
                            id: config.id,
                            name: "Clinicall Web",
                        },
                        customization: {
                            autosave: true,
                            forcesave: true,
                            buttons: {
                                print: true,
                            },
                            about: false,
                            feedback: false,
                            mobile: config.mobile || undefined,
                            mobileForceView: config.mobileForceView,
                            compactToolbar: config.compactToolbar,
                            goback: false,
                            zoom: config.zoom,
                            uiTheme: config.uiTheme,
                            macrosMode: "enable",
                            plugins: true,
                            hideNotes: false,
                            compactHeader: config.compactHeader,
                            hideRightMenu: true,
                            hideRulers: config.hideRulers,
                            toolbarNoTabs: config.toolbarNoTabs,
                            toolbarHideFileName: config.toolbarHideFileName,
                            leftMenu: false,
                            rightMenu: false,
                            toolbar: config.toolbar === true,
                            statusBar: config.statusBar === true,
                            logo: {
                                image: "https://demo.focusts.com.br/assets/images/logos/focus.png",
                                imageDark:
                                    "https://demo.focusts.com.br/assets/images/logos/focus.png",
                                url: "https://demo.focusts.com.br/assets/images/logos/focus.png",
                                imageEmbedded:
                                    "https://demo.focusts.com.br/assets/images/logos/focus.png",
                            },
                            layout: {
                                toolbar: {},
                                leftMenu: {
                                    spellcheck: false,
                                    navigation: false,
                                },
                                rightMenu: false,
                            },
                            customer: {
                                address:
                                    "Rua Senador Theotônio Vilela, 190 - 805 - Parque Bela Vista, Salvador - BA",
                                name: "Focus Tecnologia em Sistemas",
                                mail: "anagejr@focusts.com.br",
                                www: "www.focusts.com.br",
                                phone: "(71) 3343-3850",
                            },
                        },
                    },
                    events: {
                        onAppReady: (e) => this.onAppReady(e),
                        onDocumentStateChange: (e) =>
                            this.onDocumentStateChange(e),
                        onRequestEditRights: (e) => this.onRequestEditRights(e),
                        onError: (e) => this.onError(e),
                        onOutdatedVersion: (e) => this.onOutdatedVersion(e),
                        onPluginsReady: (e) => this.onPluginsReady(e),
                        onDownloadAs: (e) => this.onDownloadAs(e),
                        onRequestSaveAs: (e) => this.onRequestSaveAs(e),
                        onWarning: (e) => this.onWarning(e),
                        onRequestClose: (e) => this.onRequestClose(e),
                        onRequestMailMergeRecipients: (e) =>
                            this.onRequestMailMergeRecipients(e),
                    },
                });

                // 👇 guarda a chave do documento aqui
                this.documentKey = config.key;

                // emite o editor para outros componentes
                setTimeout(() => {
                    OnllyofficeService.editorInstance.emit(this.Editor);
                }, 500);
            } catch (ex) {
                console.error("Erro ao iniciar editor:", ex);
            }
        }
    }

    print(config) {
        if (this.Editor) {
            console.log(
                "🚀 ~ OnllyofficeService ~ print ~ this.Editor:",
                this.Editor,
            );
            //this.Editor.destroyEditor();
            this.Editor.downloadAs({ format: "pdf", name: "documento" });
        }
    }
}
